import { init, type RematchDispatch, type RematchRootState } from '@rematch/core';
import { models, type RootModel } from '@/models';

/** @deprecated */
export const store = init({
    models,
    redux: {
        // ativaçao redux tracing
        // (serve para rastrear onde foi invocada ação que lida com state)
        // descomentar somente quando precisar
        devtoolOptions: {
            trace: false,
            traceLimit: 25,
        },
    },
});

/** @deprecated */
export type RootDispatch = RematchDispatch<RootModel>;
/** @deprecated */
export type RootState = RematchRootState<RootModel>;
